export function phoneRegex(number) {
    // Validate Phone number from stackoverflow
    var phoneregex = /^\+?([0-9][0-9]{3})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;

    return !number.match(phoneregex)
}

export function emailRegex(email) {
    // Validate Email from stackoverflow
    const emailregex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    return !email.match(emailregex)   
}

export function objectHasEmptyItems(obj) {
    // This function checks if an Object has an attribute whose value is empty 
    return Object.values(obj).some(x => x === null || x === '');
}